var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImpressionssmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.16a2.17 2.17 0 1 1 0-4.33 2.17 2.17 0 0 1 0 4.33Zm0-3.58a1.42 1.42 0 1 0 0 2.84 1.42 1.42 0 0 0 0-2.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.51c-1.88 0-3.65-1.1-4.87-3.01a3.03 3.03 0 0 1 0-3c1.22-1.91 3-3.01 4.87-3.01 1.88 0 3.65 1.1 4.87 3.01.53.82.53 2.17 0 3-1.22 1.91-3 3.01-4.87 3.01Zm0-8.27c-1.61 0-3.16.97-4.24 2.66-.37.59-.37 1.61 0 2.2C2.84 8.78 4.39 9.75 6 9.75c1.62 0 3.16-.97 4.24-2.67.38-.58.38-1.6 0-2.19C9.16 3.21 7.62 2.24 6 2.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpressionssmall);
export default __webpack_public_path__ + "static/media/impressions.small.487fcff612bfc26e46bdb08bd32fdf85.svg";
export { ForwardRef as ReactComponent };